// @flow
export const routeCreator = (component: any, relativePath: string, name: string, key: string, routeOptions?: Object) => ({
	component: component,
	path: relativePath,
	name: name,
	key: key,
	...(routeOptions ? routeOptions : {}),
})